module.exports = __webpack_public_path__ + "img/winter-background.4b314643.png";